"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaffInstruction = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _staffContextProvider = require("../../contextProviders/staffContextProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StaffInstruction = exports.StaffInstruction = function StaffInstruction(_ref) {
  var script = _ref.script,
    _ref$instructions = _ref.instructions,
    instructions = _ref$instructions === void 0 ? [] : _ref$instructions,
    pet = _ref.pet,
    owner = _ref.owner,
    instructionKey = _ref.instructionKey;
  var staffContext = (0, _react.useContext)(_staffContextProvider.StaffContext);
  var hasFootnotes = instructions.find(function (instruction) {
    return instruction.footnote;
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "staffInstruction staffInstruction_".concat(instructionKey)
  }, script && /*#__PURE__*/_react["default"].createElement("strong", {
    className: "staffScriptItem"
  }, script({
    staffContext: staffContext,
    pet: pet,
    owner: owner
  }), hasFootnotes && /*#__PURE__*/_react["default"].createElement("sup", null, "*")), instructions.map(function (instruction, index) {
    var footnote = instruction.footnote,
      message = instruction.message,
      _instruction$messageS = instruction.messageStyle,
      messageStyle = _instruction$messageS === void 0 ? 'standard' : _instruction$messageS;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react["default"].createElement(_react["default"].Fragment, {
        key: "".concat(instructionKey, "_").concat(index)
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "instructionMessage ".concat(messageStyle)
      }, typeof message === 'function' ? message({
        staffContext: staffContext,
        pet: pet,
        owner: owner
      }) : message), footnote && /*#__PURE__*/_react["default"].createElement("span", {
        className: "instructionFootnote"
      }, "*", footnote))
    );
  }));
};
StaffInstruction.propTypes = {
  script: _propTypes["default"].func,
  instructions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    footnote: _propTypes["default"].string,
    message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),
    messageStyle: _propTypes["default"].oneOf(['standard', 'allCaps', 'bold', 'highAccuracy'])
  })),
  // eslint-disable-next-line react/forbid-prop-types
  pet: _propTypes["default"].any,
  // eslint-disable-next-line react/forbid-prop-types
  owner: _propTypes["default"].any,
  instructionKey: _propTypes["default"].string.isRequired
};